import { types, actions } from './requests'
export const DELETECATEGORY_TYPES = {
    ...types('DELETECATEGORY'),
}
export const DELETECATEGORY_ACTIONS = {
    ...actions('DELETECATEGORY'),
}
